import React, { useState, useEffect } from 'react'
import Button from '../../components/common/Button/Button'
import { CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react-pro'

const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60)
  const secs = seconds % 60
  return `${minutes}:${secs < 10 ? '0' : ''}${secs}`
}

const TIMEOUT = 30
export default function TimeoutModal({ onLogout }) {
  const [showModal, setShowModal] = useState(false)
  const [secondsLeft, setSecondsLeft] = useState(120)

  let inactivityTimer
  let countdownTimer

  const resetTimers = () => {
    clearTimeout(inactivityTimer)
    clearInterval(countdownTimer)

    setShowModal(false)
    setSecondsLeft(120)

    // Start new inactivity timer (28 minutes)
    inactivityTimer = setTimeout(
      () => {
        setShowModal(true)
        countdownTimer = setInterval(() => {
          setSecondsLeft((prev) => {
            if (prev <= 1) {
              clearInterval(countdownTimer)
              onLogout()
              return 0
            }
            return prev - 1
          })
        }, 1000)
      },
      (TIMEOUT - 2) * 60 * 1000,
    )
  }

  // Set up event listeners and initial timer
  useEffect(() => {
    document.addEventListener('mousemove', resetTimers)
    document.addEventListener('click', resetTimers)

    // Initialize the timer
    resetTimers()

    // Cleanup
    return () => {
      clearTimeout(inactivityTimer)
      clearInterval(countdownTimer)
      document.removeEventListener('mousemove', resetTimers)
      document.removeEventListener('click', resetTimers)
    }
  }, [])

  return (
    <CModal alignment="center" visible={showModal} onClose={() => setShowModal(false)}>
      <CModalHeader onClose={() => setShowModal(false)}>
        <CModalTitle>
          <div>Session Timeout Warning</div>
        </CModalTitle>
      </CModalHeader>
      <CModalBody>{secondsLeft && <h6>{formatTime(secondsLeft)} Until Timeout</h6>}</CModalBody>
      <CModalFooter>
        <Button color="secondary" variant="fullwidth" compressed onClick={onLogout}>
          Logout
        </Button>
        <Button color="primary" variant="fullwidth" compressed onClick={resetTimers}>
          Extend
        </Button>
      </CModalFooter>
    </CModal>
  )
}
